<script>
import utils from '@/helpers/utils';

export default {
  methods: {
    dateRange(project) {
      const { displayDate: format } = this.$root.$options.filters;
      const { createdAt, endDate, deadline } = project;
      return `${format(createdAt)} - ${format(endDate) || format(deadline)}`;
    },

    projectDetailsRoute(project) {
      const { id, status } = project;
      return status === 'Zaakceptowany i zarchiwizowany'
        ? { name: 'archive-project-single', params: { id } }
        : { name: 'project-single', params: { id } };
    },

    shortenTitle(project) {
      return utils.textExcerpt(project.name, 50);
    },
  },
};
</script>
